export const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT || 'https://api.loffre.ma/';
export const IMAGE_URL = process.env.REACT_APP_IMAGE_ENDPOINT;
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_ENDPOINT;
